import {getFormData} from '../../../utilities/helper/formDataConvertor';
import request from '../../axios';

const postLabRedesignView = async (payload: IStoreLabRedesignView) => {
  await request.post(
    '/api/v2/store/lab',
    getFormData(payload as unknown as {[name: string]: string | Blob}),
  );
};

export default postLabRedesignView;
